export const products = [
  {
    id: 1,
    title: 'Patito Chun-li',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat orci ut libero convallis molestie. Etiam eleifend luctus rhoncus. Suspendisse dignissim diam ac risus aliquet dignissim. In nibh neque, dictum quis placerat id, condimentum vitae orci. Aliquam at blandit ante. Nunc eu tortor elit. Cras ornare augue elementum, sodales ligula id, ultrices lacus.',
    img: 'https://bigamartusax.s3-accelerate.amazonaws.com/2020/07/517HBXQ6J-L._AC_SL1000_.jpg',
    stock: 10,
    price: 1000
  },
  {
    id: 2,
    title: 'Patito Ryu',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat orci ut libero convallis molestie. Etiam eleifend luctus rhoncus. Suspendisse dignissim diam ac risus aliquet dignissim. In nibh neque, dictum quis placerat id, condimentum vitae orci. Aliquam at blandit ante. Nunc eu tortor elit. Cras ornare augue elementum, sodales ligula id, ultrices lacus.',
    img: 'https://cl.buscafs.com/www.levelup.com/public/uploads/images/614383_670x670.jpg',
    stock: 10,
    price: 1000
  },
  {
    id: 3,
    title: 'Patito Ken',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat orci ut libero convallis molestie. Etiam eleifend luctus rhoncus. Suspendisse dignissim diam ac risus aliquet dignissim. In nibh neque, dictum quis placerat id, condimentum vitae orci. Aliquam at blandit ante. Nunc eu tortor elit. Cras ornare augue elementum, sodales ligula id, ultrices lacus.',
    img: 'https://media.zenfs.com/es/levelup_525/62c2f875f2189bf276f9b9adbecfaa48',
    stock: 10,
    price: 1000
  },
  {
    id: 4,
    title: 'Patito Blanca',
    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed volutpat orci ut libero convallis molestie. Etiam eleifend luctus rhoncus. Suspendisse dignissim diam ac risus aliquet dignissim. In nibh neque, dictum quis placerat id, condimentum vitae orci. Aliquam at blandit ante. Nunc eu tortor elit. Cras ornare augue elementum, sodales ligula id, ultrices lacus.',
    img: 'https://www.paturros.es/wp-content/uploads/2021/01/comprar-patito-goma-blanka-300x300.jpg',
    stock: 10,
    price: 1000
  }
]
